<template>
  <div
    class="course-wrap"
    :class="{ 'electron-course-list': isElectron, 'h5-course-wrap': isH5 }"
  >
    <p class="module-title">精品课程</p>
    <div class="course-list">
      <CourseCard
        :groupInfo="item.group_buy_info || {}"
        v-for="item in couseList"
        :key="item.id"
        :courseInfo="item"
        :orgInfo="item.org"
      />
    </div>
  </div>
</template>

<script>
import { isH5, isPad } from "@saas/components/src";
import CourseCard from "./CourseCard.vue";
export default {
  props: {
    couseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      isPad: isPad(),
      isElectron: window.isElectron,
    };
  },
  components: {
    CourseCard,
  },
  methods: {
    handleCourseInfo(item) {
      return {
        ...item,
        ...item.course_info,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.course-wrap {
  padding-top: 16px;
  padding-bottom: 0px;
  .module-title {
    margin-bottom: 22px;
  }
  .course-list {
    display: flex;
    flex-wrap: wrap;
    width: 1212px;
    position: relative;
    left: -12px;
  }
  .electron-course-list {
    width: 992px;
  }
}

// 客户端
.course-wrap.electron-course-list {
  padding-top: 25px;
  .course-list {
    width: 992px;
  }
}

// h5样式
.course-wrap.h5-course-wrap {
  padding: 0.43rem 0.28rem 0;
  .course-list {
    width: 100%;
    position: static;
  }
}
</style>
